import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import { ArtistJsonDataPublic } from 'nfty-common/lib/model/artist.model';
import { CSSProperties } from 'react';
import { PropsBase } from '../model/props-base';
import { ArtistName } from './artist-name.component';

export interface ArtistAvatarProps extends PropsBase {
    artist: ArtistJsonDataPublic;
}

export const ArtistAvatar = observer((props: ArtistAvatarProps) => {
    const { artist } = props;

    const imgStyle: CSSProperties = {
        boxShadow: '2px 4px 10px black',
        objectFit: 'cover',
        height: '40vh',
        width: '100%'
    };

    return (
        <div className="h-100 w-100 text-center pb-2">
            <img className="hover-expand t-100" style={imgStyle} src={artist.images.thumbnail.data} alt="Artist Portrait" />
            <div className="my-4 d-flex flex-column align-items-center">
                <h5 className="mb-0 px-3 bg-darker">
                    <ArtistName {...artist} />
                </h5>
                <span className="bg-darker px-3 text-secondary text-avenir-re">﹣ SEASON 01 ﹣</span>
            </div>
            <div className="d-flex justify-content-center text-primary">
                <a className="mx-1" target="_blank" href={artist.website} rel="noreferrer">
                    <span className="fa-layers fa-2x fa-fw ">
                        <FontAwesomeIcon transform={{ size: 20 }} icon="circle" />
                        <FontAwesomeIcon className="text-light" transform="shrink-6" icon={['fab', 'instagram']} />
                    </span>
                </a>
                <a className="mx-1" target="_blank" href={artist.website} rel="noreferrer">
                    <span className="fa-layers fa-2x fa-fw ">
                        <FontAwesomeIcon transform={{ size: 20 }} icon="circle" />
                        <FontAwesomeIcon className="text-light" transform="shrink-8" icon={['fab', 'twitter']} />
                    </span>
                </a>
                <a className="mx-1" target="_blank" href={artist.website} rel="noreferrer">
                    <span className="fa-layers fa-2x fa-fw ">
                        <FontAwesomeIcon transform={{ size: 20 }} icon="circle" />
                        <FontAwesomeIcon className="text-light" transform="shrink-8" icon="link" />
                    </span>
                </a>
            </div>
        </div>
    );
});